/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Kpi_Contract_Seats_BadgeInputs */



/**
* | output |
* | --- |
* | "Seats only — no prepaid usage" |
*
* @param {Partner_Org_Kpi_Contract_Seats_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_kpi_contract_seats_badge = /** @type {((inputs?: Partner_Org_Kpi_Contract_Seats_BadgeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Kpi_Contract_Seats_BadgeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur Plätze — keine vorausbezahlte Nutzung")
	return /** @type {LocalizedString} */ ("Seats only — no prepaid usage")
});